import { PropTypes } from 'prop-types';

export const currencyPropType = PropTypes.shape({
  C: PropTypes.string,
  M: PropTypes.number,
  F: PropTypes.number,
});
